export class DialogModelCommonConfirm {
    constructor(
      public message: any
    ) {}
  }
  